import React from 'react'

export default function Topbar() {
  return (
    <div className='w-full h-[50px] bg-[#DEEDF5]'></div>
  )
}
